import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentUser } from '../selectors/users';

import { userRoles } from '../constants';

import Popout from './popout';

import IconCheckCircled from '../icons/icon-check-circled';

const Role = ({ id, isSelected, title, onClick }) => {
    const handleClick = () => {
        onClick(id);
    }

    return (
        <li key={id} className={'pair-item' + (isSelected ? ' selected' : '')} onClick={handleClick}>
            <span className="key">
                { title }

            </span>

            <span className="value">
                <IconCheckCircled />
            </span>
        </li>
    )
}

class HideFrom extends PureComponent {
    static defaultProps = {
        xAlign: 'left',
        defaultXPosition: 'right',
        hidden: []
    }

    state = {
        visible: false
    }

    handleClick = () => {
        this.popoutCtrl && this.popoutCtrl.show();
    }

    handlePopoutShow = () => {
        this.setState({
            visible: true
        });
    }

    handlePopoutHide = () => {
        this.setState({
            visible: false
        });
    }

    handleRoleSelect = roleId => {
        const { hidden, onHide, onReveal } = this.props;

        if (hidden.includes(roleId)) {
            onReveal && onReveal([roleId]);
        } else {
            onHide && onHide([roleId]);
        }

        this.popoutCtrl && this.popoutCtrl.hide();
    }

    handleToggleAll = () => {
        const { hiddenFromAll, roles, props, popoutCtrl } = this;
        const { onHide, onReveal } = props;
        const roleIds = roles.map(({ id }) => id);

        if (hiddenFromAll) {
            onReveal(roleIds);
        } else {
            onHide(roleIds);
        }

        popoutCtrl && popoutCtrl.hide();
    }

    get roles() {
        const { creator, currentUserId, currentUserRole } = this.props;
        const roles = userRoles();
        const currentRoleAccessLevel = roles.find(role => role.id === currentUserRole)?.accessLevel ?? 4;

        return roles
            .filter(role =>
                role.accessLevel > 1 &&
                (currentUserId === creator ? role.accessLevel >= currentRoleAccessLevel : role.accessLevel > currentRoleAccessLevel)
            )
            .sort((r1, r2) => r1.accessLevel - r2.accessLevel);
    }

    get hiddenFromAll() {
        const { roles, props } = this;
        const { hidden } = props;

        return roles.every(role => hidden.includes(role.id));
    }

    setPopoutCtrl = ctrl => this.popoutCtrl = ctrl;

    componentDidMount() {
        const ctrl = {
            show: event => {
                this.popoutCtrl && this.popoutCtrl.show();
            }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }
    }

    componentWillUnmount() {
        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController && this.props.provideController(null);
            }
        }
    }

    render() {
        const { roles, handleClick, setPopoutCtrl, handlePopoutShow, handlePopoutHide, handleRoleSelect, handleToggleAll, props, state, hiddenFromAll } = this;
        const { children, hidden, xAlign, defaultXPosition } = props;
        const { visible } = state;

        if (!roles.length) {
            return null;
        }

        const childrenWithProps = React.Children.map(children, child => {
            return React.cloneElement(child, {
                onClick: handleClick,
                className: (child.props.className || '') + (visible ? ' selected' : '')
            });
        });

        return (
            <React.Fragment>
                { childrenWithProps }

                <Popout
                    className="xxxxsmall no-arrow"
                    xAlign={xAlign}
                    defaultXPosition={defaultXPosition}
                    provideController={setPopoutCtrl}
                    onShow={handlePopoutShow}
                    onHide={handlePopoutHide}
                >
                    <div className="popout-main">
                        <ul className="popout-checklist widget-box-select-list">
                            <Role key="all" id="all" title={(hiddenFromAll ? 'Show for all' : 'Hide from all')} onClick={handleToggleAll} />

                            {
                                roles.map(({ id, title }) => (
                                    <Role key={id} id={id} title={`${title}s`} isSelected={hidden.includes(id)} onClick={handleRoleSelect} />
                                ))
                            }
                        </ul>
                    </div>
                </Popout>
            </React.Fragment>
        );
    }
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();

    return ({ auth, users, teamChat, teams, subteams, projects, sidebar, appProps, notifications }) => {
        const currentUser = getCurrentUser(users);

        return {
            currentUserId: currentUser?.id,
            currentUserRole: currentUser?.role
        }
    };
}

export default connect(makeMapStateToProps)(HideFrom);
